<page-header  (showBlockedChanged)="initVideos()"></page-header>

<h1>תגית: {{tag.name}}</h1>

<videos *ngIf="tag.videos.length" [videos]="tag.videos" class="videos"></videos>
<h1 *ngIf="!loading&&!tag.videos.length">לא נמצאו תוצאות</h1>

<div class="loading-div" *ngIf="tag.videos.length==0&&loading">
    <div class="d-flex justify-content-center">
        <div class="spinner-border large-spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <span>אנחנו טוענים עבורך את הסרטונים...</span>
</div>

<div *ngIf="loading&&tag.videos.length>0" class="bottom-spinner">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>